import { createFileRoute, redirect } from "@tanstack/react-router";
import { ACCOUNT_UI_URL } from "@/lib/const";

const registerUrl = `${ACCOUNT_UI_URL}/registerOrRedirect`;

export const Route = createFileRoute("/register")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: `${registerUrl}${location.searchStr}` });
  },
  component: RegisterRedirect,
});

function RegisterRedirect() {
  return null;
}
